export default "__VITE_ASSET__Wkmk9mYN__"